module Meevo.Plugins.AlertsManager {

    import IAlertJSON = Meevo.Model.IAlertJSON;

    interface IItem {
        id: string;
        displayName: string;
    }

    interface IMoverAlertJson extends IAlertJSON {
        [key: string]: any;
    }

    class MeevoAlertManagerMoverConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService'
        ];

        public params: IParams;
        public data: IMoverData;

        public selectedItems: IItem[] = [];

        get dataForReview() {
            return (this.selectedItems || []).map(item => item.displayName);
        }

        get alertConfiguration() {
            return {
                [this.data.configKey]: (this.selectedItems || []).map(item => item.id)
            }
        }

        onEdit(alertJSON: IMoverAlertJson): void {
            switch (this.data.moverTemplate) {
                case 'service':
                    this.alertsManagerService.getServicesByIds(alertJSON[this.data.configKey])
                        .then((res: IItem[]) => this.selectedItems = res);
                    break;
                default:
                    this.selectedItems = alertJSON[this.data.configKey].map(itemId => (<IItem>{ id: itemId }));
            }
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoAlertManagerMoverConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/mover-config/mover-config.component.html',
            controller: MeevoAlertManagerMoverConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        });
}